exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-cruip-js": () => import("./../../../src/pages/cruip.js" /* webpackChunkName: "component---src-pages-cruip-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-saas-one-js": () => import("./../../../src/pages/saas_one.js" /* webpackChunkName: "component---src-pages-saas-one-js" */)
}

